export default "Suramortissement art. 39 quinquies AA — Chaleur renouvelable tertiaire | Solution Éco France";
